"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakpointsSettings = exports.default = void 0;
var Breakpoints_1 = require("./Breakpoints");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Breakpoints_1).default; } });
var Settings_1 = require("./Settings");
Object.defineProperty(exports, "BreakpointsSettings", { enumerable: true, get: function () { return __importDefault(Settings_1).default; } });
